// extracted by mini-css-extract-plugin
export default {"greetings":"Home_greetings__mGs2U","intro":"Home_intro__CIR63","title":"Home_title__xBsdV"};